export const RIGHTS = 'md_rights_GLOBAL';